<template>
  <div class="filter-container">
    <div class="grid-item">
      <!-- First row - Show All button -->
      <!-- <div class="filter-row">
        <button
          :class="['buy', { buyActive: isActive('all') }]"
          @click="$emit('filter-change', 'all')"
        >
          <span class="white-text">Show All</span>
        </button>
      </div> -->

      <!-- First row - Show All button -->
      <div class="filter-row image-row">
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('all') }"
          @click="$emit('filter-change', 'all')"
        >
          <img src="../rubik/images/img-all-40.png" alt="All" />
        </button>
      </div>
      <!-- Second row - Image buttons for piece count -->
      <div class="filter-row image-row">
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('1piece') }"
          @click="$emit('filter-change', '1piece')"
        >
          <img src="../rubik/images/img1-40.png" alt="1 Piece" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('2piece') }"
          @click="$emit('filter-change', '2piece')"
        >
          <img src="../rubik/images/img2-40.png" alt="2 Pieces" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('3piece') }"
          @click="$emit('filter-change', '3piece')"
        >
          <img src="../rubik/images/img3-40.png" alt="3 Pieces" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('4piece') }"
          @click="$emit('filter-change', '4piece')"
        >
          <img src="../rubik/images/img4-40.png" alt="4 Pieces" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('5piece') }"
          @click="$emit('filter-change', '5piece')"
        >
          <img src="../rubik/images/img5-40.png" alt="5 Pieces" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('3missing') }"
          @click="$emit('filter-change', '3missing')"
        >
          <img src="../rubik/images/img-empty3-40.png" alt="3 Missing" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('2missing') }"
          @click="$emit('filter-change', '2missing')"
        >
          <img src="../rubik/images/img-empty2-40.png" alt="2 Missing" />
        </button>
      </div>

      <!-- Third row - Shape filters -->
      <div class="filter-row image-row">
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('rocketshape') }"
          @click="$emit('filter-change', 'rocketshape')"
        >
          <img src="../rubik/images/img100-40.png" alt="Rocket" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('lshape1') }"
          @click="$emit('filter-change', 'lshape1')"
        >
          <img src="../rubik/images/img109-40.png" alt="L Shape 1" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('lshape2') }"
          @click="$emit('filter-change', 'lshape2')"
        >
          <img src="../rubik/images/img119-40.png" alt="L Shape 2" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('lineshape') }"
          @click="$emit('filter-change', 'lineshape')"
        >
          <img src="../rubik/images/img101-40.png" alt="Line" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('sshape') }"
          @click="$emit('filter-change', 'sshape')"
        >
          <img src="../rubik/images/img103-40.png" alt="S Shape" />
        </button>
      </div>

      <!-- Fourth row - More shapes -->
      <div class="filter-row image-row">
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('buildingshape') }"
          @click="$emit('filter-change', 'buildingshape')"
        >
          <img src="../rubik/images/img99-40.png" alt="Building" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('tshape') }"
          @click="$emit('filter-change', 'tshape')"
        >
          <img src="../rubik/images/img111-40.png" alt="T Shape" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('crossshape') }"
          @click="$emit('filter-change', 'crossshape')"
        >
          <img src="../rubik/images/img98-40.png" alt="Cross" />
        </button>
        <button
          class="img-btn"
          :class="{ selectedImg: isActive('cshape') }"
          @click="$emit('filter-change', 'cshape')"
        >
          <img src="../rubik/images/img78-40.png" alt="C Shape" />
        </button>
      </div>

      <div class="filter-row image-row">
        <div class="learn-btn-container">
          <button
            class="img-btn"
            :class="{ selectedImg: isActive('tolearn') }"
            @click="$emit('filter-change', 'tolearn')"
            @contextmenu.prevent="$emit('edit-set', 'tolearn')"
            title="Left click to filter | Right click to edit"
          >
            <img src="../rubik/images/img-learn-40.png" alt="To Learn 1" />
            <button
              class="edit-btn"
              @click.stop="$emit('edit-set', 'tolearn')"
              title="Edit To Learn Set 1"
            >
              ✏️
            </button>
          </button>
        </div>

        <div class="learn-btn-container">
          <button
            class="img-btn"
            :class="{ selectedImg: isActive('tolearn2') }"
            @click="$emit('filter-change', 'tolearn2')"
            @contextmenu.prevent="$emit('edit-set', 'tolearn2')"
            title="Left click to filter | Right click to edit"
          >
            <img src="../rubik/images/img-learn-40.png" alt="To Learn 2" />
            <button
              class="edit-btn"
              @click.stop="$emit('edit-set', 'tolearn2')"
              title="Edit To Learn Set 2"
            >
              ✏️
            </button>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  activeFilter: {
    type: String,
    required: true,
  },
});

defineEmits(['filter-change', 'edit-set']);

const isActive = (filterKey) => {
  return props.activeFilter === filterKey;
};
</script>

<style scoped>
.filter-container {
  margin-bottom: 10px;
}

.grid-item {
  background-color: #f4fbfe;
  padding: 10px;
  text-align: center;
  color: #f08200;
  border: 2px solid #f08200;
  font-weight: bold;
  border-radius: 6px;
}

.filter-row {
  margin-bottom: 10px;
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  gap: 2px;
}

.image-row {
  margin-bottom: 12px;
}

.white-text {
  color: #fff;
}

.img-btn {
  background: none;
  border: none;
  width: 50px;
  height: 50px;
  cursor: pointer;
  padding-left: 4px;

  transition: background-color 0.3s;
}

.img-btn img {
  display: table-cell;
  width: 40px;
  height: 40px;
}

.img-btn.selectedImg {
  background-color: hsla(206, 87%, 61%, 0.65);
  border-radius: 4px;
}

.img-btn:hover {
  background-color: hsla(206, 87%, 61%, 0.65);
  border-radius: 4px;
}

.learn-btn-container {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  position: relative;
}

.edit-btn2 {
  background-color: white;
  border: 2px solid #f08200;
  color: #f08200;
  font-size: 16px;
  width: 25px;
  height: 25px;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative; /* ← ADD THIS LINE */
  transition: all 0.3s;
}

.edit-btn {
  position: absolute; /* ← ADD */
  top: 0; /* ← ADD */
  right: 0; /* ← ADD */

  border: 2px solid #f08200; /* ← CHANGE from #44a8f2 */
  color: white;
  font-size: 12px; /* ← CHANGE from 16px */
  width: 22px; /* ← CHANGE from 30px */
  height: 22px; /* ← CHANGE from 30px */
  border-radius: 3px; /* ← CHANGE from 4px */
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
  z-index: 10; /* ← ADD */
}

.edit-btn:hover {
  background-color: #f05800;
  transform: scale(1.5);
}
</style>
